const Auth = function (restClient) {
  this.restClient = restClient
}

Auth.prototype.whoami = function () {
  return this.restClient.get('/auth/whoami')
}

export default Auth
